<!-- <img class="width-100 mg-bottom-10" src="assets/dmi-loader.gif">
<div class="fw-700 fs-13 txt-center">Please wait ...</div> -->


<div class="loadingio-spinner-rolling-sray298du2g">
    <div class="ldio-ti8ltt9443b">
        <div></div>
    </div>
</div>